export default __webpack_public_path__ + "static/indoor9-57726d463889f54844585be49a163aec.webp";